import Vue from 'vue';
import EdocUi from '@silae/edoc-ui';
import App from './App.vue';
import router from './router';
import store from './store';
import 'babel-polyfill';

import '@silae/edoc-lib';
import { getRuntimeConfig } from './http';

function loadRuntimeConfig() {
  return getRuntimeConfig().then((res) => {
    Vue.prototype.$runtimeConfig = res;
  });
}

Vue.use(EdocUi);
require('@silae/edoc-ui/lib/assets/scss/main.scss');
require('@/assets/scss/main.scss');

Vue.config.productionTip = false;

store.dispatch('auth/check');
loadRuntimeConfig().then(() => {
  new Vue({
    router,
    store,
    render: h => h(App),
  }).$mount('#app');
});
